var map = {
	"./Posters BAM Impressão-01.png": 77,
	"./Posters BAM Impressão-02.png": 7583,
	"./Posters BAM Impressão-03.png": 5260,
	"./Posters BAM Impressão-04.png": 2662,
	"./Posters BAM Impressão-05.png": 5699,
	"./Posters BAM Impressão-06.png": 2492,
	"./Posters BAM Impressão-07.png": 1230,
	"./Posters BAM Impressão-08.png": 5730,
	"./Posters BAM Impressão-09.png": 2748
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 331;